import React from "react";
import { Alert } from "antd";
import "./style.css";

const NoDataFound_Chart = () => {
	return (
		<div className="no_data_chart">
			<Alert message="No data found !" type="warning" showIcon />
		</div>
	);
};

export default NoDataFound_Chart;
